import { Form } from '@calendly/form';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const subsectionCss = "s1t8p0ro";
export const Subsection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(subsectionCss, props.className)} />;
});
const wrapperCss = "w18tolo4";
export const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const styledFormCss = "suften7";
export const StyledForm = forwardRef((props, ref) => <Form ref={ref} {...props} className={classNames(styledFormCss, props.className)} />);
const formBodyIsSmallPhoneCss = "ftbnpel";
const formBodySpacelessCss = "f11ivvfb";
const formBodyCss = "fqb6nm7";
export const FormBody = forwardRef((props, ref) => {
  const {
    spaceless,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <Component ref={ref} {...restProps} className={classNames(formBodyCss, {
    [formBodyIsSmallPhoneCss]: isSmallPhone,
    [formBodySpacelessCss]: spaceless
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");